import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M52.4301 62.41C52.4301 62.41 47.2601 67.8 49.4601 79.47C51.2901 89.19 51.0001 94.11 49.0201 95.43C49.0201 95.43 53.6401 96.86 56.2901 93.78C56.2901 93.78 56.0701 101.6 62.7901 104.9C69.1601 108.03 73.9101 109.19 73.9101 115.36C73.9101 115.36 80.3001 104.79 74.1301 96.64C74.1301 96.64 80.0701 97.96 80.9601 103.03C80.9601 103.03 83.7101 96.86 79.9701 92.9C77.0801 89.84 76.7801 88.06 77.0001 84.75C77.2201 81.45 78.9801 76.16 75.9001 72.64C72.8201 69.12 70.2601 70.16 67.9701 67.58C65.4401 64.72 66.1001 59.98 61.5801 58.99C56.0101 57.78 52.4301 62.41 52.4301 62.41Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M58.2605 65.8125C58.3976 66.4532 58.5614 67.0854 58.7522 67.7069L58.7522 67.7069L58.7544 67.7139C59.1959 69.0794 59.8033 70.3896 60.5897 71.5707C60.9706 72.183 61.4313 72.7363 61.8685 73.2531L61.8738 73.2593L61.8793 73.2654C62.3516 73.788 62.8464 74.3133 63.363 74.8202C63.8558 75.3429 64.3711 75.8518 64.8842 76.3575L64.9348 76.4074C65.4354 76.9006 65.9335 77.3915 66.4183 77.9001C67.4193 78.9504 68.3472 80.0603 69.073 81.3626C69.3943 81.9446 69.6395 82.5736 69.8037 83.2219C69.5754 82.5967 69.2775 82.0017 68.9223 81.4422L68.9224 81.4421L68.9179 81.4353C68.1391 80.2515 67.16 79.1925 66.1185 78.1914C65.6905 77.7718 65.2621 77.3602 64.8332 76.9481C64.225 76.3638 63.6158 75.7786 63.0054 75.1682C62.5049 74.6577 62.0138 74.1276 61.5324 73.5776C61.5126 73.5532 61.4928 73.529 61.4731 73.5047C61.0095 72.9353 60.5766 72.4036 60.2479 71.8084L60.2481 71.8083L60.2413 71.7967C59.4914 70.5209 58.9048 69.1602 58.5986 67.763L58.5986 67.763L58.5974 67.7579C58.4493 67.1143 58.3368 66.4645 58.2605 65.8125Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M73.4 84.1839C73.403 83.8975 73.4118 83.6004 73.422 83.2993C73.4157 83.5902 73.4101 83.8864 73.41 84.1948C73.4057 84.4003 73.4015 84.6067 73.3979 84.8137C73.398 84.6039 73.3989 84.394 73.4 84.1839Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M57.5298 78.9556C57.6492 79.1324 57.7729 79.3075 57.8998 79.4812C57.7709 79.3085 57.6447 79.1335 57.5215 78.9556C57.4401 78.8378 57.3599 78.7192 57.2808 78.5997C57.3623 78.7192 57.4453 78.8379 57.5298 78.9556Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M66.1919 93.4181C66.2171 93.5383 66.2447 93.6578 66.2746 93.7766C66.2431 93.6623 66.2143 93.5473 66.1881 93.4318C66.163 93.3162 66.1398 93.2003 66.1186 93.0841C66.1416 93.1957 66.166 93.307 66.1919 93.4181Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M73.76 18.48L31.98 1.46997C31.98 1.46997 11.94 5.12998 5.56 6.41998C5.56 6.41998 -0.22001 9.05998 1.92999 17.98C4.07999 26.9 5.07002 31.19 2.59002 33.83C2.59002 33.83 5.88998 36.14 9.85998 34.66C9.85998 34.66 7.42999 40.36 8.36999 46.05C9.52999 52.99 14.92 54.13 14.37 57.77C14.37 57.77 21.85 57.77 25.17 51.08C25.17 51.08 30.88 58.84 41.39 61.25C52.95 63.89 62.86 60.09 66.49 57.95C69.42 56.22 71.2801 56.46 72.4301 58.94C72.4301 58.94 77.2 56.72 79.04 50.35C83.01 36.65 73.76 18.48 73.76 18.48Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
